import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { RouterModule } from '@angular/router';
import { AuthenticationDomainService } from 'src/app/modules/authentication/services/authentication-domain.service';
import { UsersDomainService } from 'src/app/modules/users/services/users-domain.service';
import { combineLatest, map, startWith } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OfflineComponent } from 'src/app/shared/utils/offline/offline.component';
import { AuthUserService } from '../../services/auth-user/auth-user.service';
import { OfflineDomainService } from 'src/app/shared/utils/offline/services/offline-domain.service';
import { Permission } from 'src/app/modules/roles/constants/roles.constants';
import { DisabledDirective } from 'src/app/shared/directives/disabled.directive';

@Component({
  selector: 'app-layout-header',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, DisabledDirective],
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutHeaderComponent {
  @Output()
  protected toggleMenu = new EventEmitter<void>();

  protected readonly user$ = this.usersDomainService.getProfile().pipe(takeUntilDestroyed());
  protected readonly profile$ = this.usersDomainService.getProfile().pipe(takeUntilDestroyed());
  protected readonly avatar$ = this.usersDomainService.avatarChanges.pipe(
    takeUntilDestroyed(),
    startWith('/assets/images/logo/duoges.png')
  );

  protected readonly badgeColor$ = this.offlineDomainService.activated$.pipe(
    takeUntilDestroyed(),
    map((activated) => (activated ? 'warn' : 'primary'))
  );

  protected readonly hasOfflineCapabilities = this.authUserService.hasPermission(
    Permission.OfflineCapabilities
  );

  protected readonly offlineIsActivated$ =
    this.offlineDomainService.activated$.pipe(takeUntilDestroyed());

  protected readonly vm = Object.freeze({
    avatar: toSignal(this.avatar$),
    profile: toSignal(this.profile$),
    badgeColor: toSignal(this.badgeColor$, { requireSync: true }),
    offlineIsActivated: toSignal(this.offlineIsActivated$, { requireSync: true }),
  });

  constructor(
    private readonly authenticationDomainService: AuthenticationDomainService,
    private readonly usersDomainService: UsersDomainService,
    private readonly matDialog: MatDialog,
    private readonly authUserService: AuthUserService,
    private readonly offlineDomainService: OfflineDomainService
  ) {}

  logOut = () => {
    this.authenticationDomainService.logOut();
  };

  protected toggleOffline = () => {
    this.matDialog.open(OfflineComponent).afterClosed();
  };
}
